import React, { useState } from 'react';
import lockImg from '../../assets/svg/lock.svg';
import api from '@api';
import navigate from '@utils/navigate';

export default function Login() {
	const [loading, setLoading] = useState(false);
	const usuario = React.createRef();
	const senha = React.createRef();

	const onSubmit = (e) => {
		e.preventDefault();
		const username = usuario.current.value;
		const password = senha.current.value;

		if (username && password) {
			setLoading(true);
			api.auth.login(username, password)
				.then(() => navigate('/'))
				.finally(() => {
					setLoading(false);
				});
		}
	};

	if (api.auth.accessToken() !== undefined) navigate('/');

	return (
		<div className="d-flex align-items-center mx-auto" style={{ minHeight: '100vh', maxWidth: '600px' }}>

			<form className="d-flex flex-column w-100 bg-white border rounded p-3" onSubmit={onSubmit}>

				<div className="text-center"><img src={lockImg} alt="lock" height={70} /></div>

				<div className="col-12 mb-3">
					<label htmlFor='usuario' className='form-label'>Usuario</label>
					<input className="form-control" id="usuario" name="usuario" type="text" ref={usuario} required />
				</div>

				<div className="col-12 mb-4">
					<label htmlFor='password' className='form-label'>Senha</label>
					<input className="form-control" id="senha" name="senha" type="password" ref={senha} required />
				</div>

				<button className="ms-auto px-5 btn btn-primary" type="submit" disabled={loading}>
					{!!loading && <span className="spinner-border spinner-border-sm me-2" />}
					Entrar
				</button>
			</form>
		</div>
	);
}

export function Logout() {
	api.auth.logout();

	return null;
}
